import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '@/hooks/useRouter';
import User from '@/pages/_common_user/ManageUser';
import useQuery from './useQuery';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';

export default function Layout() {
  const { location } = useRouter();
  const launch = useDialogLauncher();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  const csvQuery = useQuery({
    returnCsvQuery: true
  });

  function onDownload(query) {
    launch(DialogManager.CSVDownload.Config(query));
  }

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Educators']}
      title="Starred Educators"
      description={(
        <span>
          These are educators that you starred. CommunityShare recommends using this page to help
          track educators you want to pay special attention to.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      csvQuery={function () {
        onDownload(csvQuery);
      }}
      row={function(user) {
        return (
          <User key={user.id} user={user} />
        );
      }}
    />
  );
}
